import {
  GET_DIGITAL_PROTOCOL_LANDING_INFO_URL,
  UPDATE_DIGITAL_PROTOCOL_LANDING_TITLE_URL,
  COHORTS_URL,
  COHORTS_NOT_LINKED_URL,
  SOA_LIST_URL,
  GET_DIGITAL_PROTOCOL_SOA,
  FINALIZE_SOA_URL,
  UPDATE_ARM_COHORT_IN_SOA_LIST_URL,
  UPDATE_UNIT_IN_SOA_LIST_URL,
  GET_UNIT_IN_SOA_LIST_URL,
  DEL_SOA_TABLE_LIST_URL,
  ADD_SOA_TABLE_LIST_URL,
  GET_SOA_ACTIVITY_LIBRARY_URL,
  GET_FOOTNOTE_TYPE_LIST_URL,
  SAVE_SOA_ACTIVITY_URL,
  GET_FOOTNOTE_DATA_URL,
  GET_FOOTNOTE_DROPDOWN_OPTIONS_URL,
  FOOTNOTE_DETAIL_URL,
  UPDATE_SOA_TABLE_NAME_URL,
  EXPORT_AS_EXCEL_URL,
  ARM_COHORT_URL,
  ENDPOINT_URL,
  GET_ANALYSIS_SET_LIST,
  GET_STATS_LIB,
  GET_ENDPOINT_LIB,
  FINALIZE_STATUS_URL,
  STUDY_POPULATION_URL,
  STUDY_POPULATION_GET_URL,
} from './apis'
import { post, get, doPatch, doDelete } from 'src/utils/ajax-proxy'

export const getDpLandingInfo = async (trial_uuid: string, user_name: string) => {
  return await get(
    `${GET_DIGITAL_PROTOCOL_LANDING_INFO_URL}?trial_uuid=${trial_uuid}&&user_name=${user_name}`,
    true
  )
}

export const updateDpLandingTitle = async (payload: any) => {
  return await post(UPDATE_DIGITAL_PROTOCOL_LANDING_TITLE_URL, payload, true)
}

export const getDpCohortList = async (trial_uuid: string) => {
  return await get(`${COHORTS_URL}?trial_uuid=${trial_uuid}`, true)
}

export const getDpCohortNotLinkedList = async (payload: any) => {
  return await post(COHORTS_NOT_LINKED_URL, payload, true)
}

export const addDpCohort = async (payload: any) => {
  return await post(COHORTS_URL, payload, true)
}

export const updateCohortById = async (payload: any) => {
  return await doPatch(COHORTS_URL, payload, true)
}

export const deleteCohortById = async (payload: any) => {
  return await doDelete(COHORTS_URL, payload, true)
}

export const getDpSoaList = async (trial_uuid: string) => {
  return await get(`${SOA_LIST_URL}?trial_uuid=${trial_uuid}`, true)
}

export const deleteSoaTableById = async (payload: any) => {
  return await doDelete(DEL_SOA_TABLE_LIST_URL, payload, true)
}

export const addSoaTable = async (payload: any) => {
  return await post(ADD_SOA_TABLE_LIST_URL, payload, true)
}

export const updateArmCohortInSoaTableList = async (payload: any) => {
  return await post(UPDATE_ARM_COHORT_IN_SOA_LIST_URL, payload, true);
}

export const updateUnitInSoaTableList = async (payload: any) => {
  return await post(UPDATE_UNIT_IN_SOA_LIST_URL, payload, true)
}

export const getDpUnits = async (trial_uuid: string) => {
  return await get(`${GET_UNIT_IN_SOA_LIST_URL}?trial_uuid=${trial_uuid}`, true)
}

export const getDpSoaTable = async (dprot_id: number, trial_id:string, user_name: string) => {
    return await get(`${GET_DIGITAL_PROTOCOL_SOA}?trial_uuid=${trial_id}&dprot_id=${dprot_id}&user_name=${user_name}`, true);
}

export const finalizeDpSoaTable = async (payload: any) => {
  return await post(FINALIZE_SOA_URL, payload, true)
}

export const getSoaActivityLib = async (trial_uuid: string) => {
  return await get(`${GET_SOA_ACTIVITY_LIBRARY_URL}?trial_uuid=${trial_uuid}`, true)
}

export const getFootnoteTypeList = async () => {
  return await get(`${GET_FOOTNOTE_TYPE_LIST_URL}`, true)
}

export const getFootnoteDropdownOptionsList = async () => {
  return await get(`${GET_FOOTNOTE_DROPDOWN_OPTIONS_URL}`, true)
}

export const saveSoaActivity = async (payload: any) => {
  return await post(SAVE_SOA_ACTIVITY_URL, payload, true)
}

export const getFootnoteData = async (trial_uuid: string, table_id: number) => {
  return await get(`${GET_FOOTNOTE_DATA_URL}?trial_uuid=${trial_uuid}&table_id=${table_id}`, true)
}

export const insertFootnoteDetail = async (payload: any) => {
  return await post(`${FOOTNOTE_DETAIL_URL}`, payload, true)
}

export const updateFootnoteDetail = async (payload: any) => {
  return await doPatch(`${FOOTNOTE_DETAIL_URL}`, payload, true)
}

export const deleteFootnoteDetail = async (payload: any) => {
  return await doDelete(`${FOOTNOTE_DETAIL_URL}`, payload, true)
}

export const updateSoaTableName = async (payload: any) => {
  return await doPatch(`${UPDATE_SOA_TABLE_NAME_URL}`, payload, true)
}

export const exportAsExcel = async (payload: any) => { 
  return await doPatch(`${EXPORT_AS_EXCEL_URL}`, payload, true, 'PUT')
}

export const getDpArmList = async (trial_uuid: string, arm_ids?: string) => {
  return await get(`${ARM_COHORT_URL}?trial_uuid=${trial_uuid}${arm_ids ? `&arm_id=${arm_ids}`: ``}`, true);
}

export const addDpArm = async (payload: any) => {
  return await post(ARM_COHORT_URL, payload, true)
}

export const updateArm = async (payload: any) => {
  return await doPatch(ARM_COHORT_URL, payload, true)
}

export const deleteArmById = async (payload: any) => {
  return await doDelete(ARM_COHORT_URL, payload, true)
}

export const getDpEndpointList = async (trial_uuid: string, p0?: { signal: AbortSignal }) => {
  return await get(`${ENDPOINT_URL}?trial_uuid=${trial_uuid}`, true)
}

export const insertEndpointDetail = async (payload: any) => {
  return await post(`${ENDPOINT_URL}`, payload, true)
}

export const updateEndpointDetail = async (payload: any) => {
  return await doPatch(`${ENDPOINT_URL}`, payload, true)
}

export const deleteEndpointDetail = async (payload: any) => {
  return await doDelete(`${ENDPOINT_URL}`, payload, true)
}  

export const getEndpointLibraryList = async () => {
  return await get(`${GET_ENDPOINT_LIB}`, true)
}

export const getStatsLibraryList = async (trial_uuid: string) => {
  return await get(`${GET_STATS_LIB}?trial_uuid=${trial_uuid}`, true)
}

export const getStudyAnalysisLibraryList = async (trial_uuid: string) => {
  return await get(`${GET_ANALYSIS_SET_LIST}?trial_uuid=${trial_uuid}`, true)
}

// to be enabled when API is implemented
// export const updateUnitInEndpointTableList = async (payload: any) => {
//   return await post(UPDATE_UNIT_IN_ENDPOINT_LIST_URL, payload, true)
// }

export const getFinalizeStatus = async (trial_uuid: string) => {
  return await get(`${FINALIZE_STATUS_URL}?trial_uuid=${trial_uuid}`, true)
}

export const patchFinalizeStatus = async (payload: any) => {
  return await doPatch(FINALIZE_STATUS_URL, payload, true)
}
  
export const getStudyPopulationList = async (trial_uuid: string) => {
  return await get(`${STUDY_POPULATION_GET_URL}?trial_uuid=${trial_uuid}`, true)
}

export const getStudyAnalysisSetList = async (trial_uuid: string) => {
  return await get(`${STUDY_POPULATION_URL}?trial_uuid=${trial_uuid}`, true)
}

export const saveStudyPopulation = async (payload: any) =>{
  return await post(STUDY_POPULATION_URL, payload, true)
}

export const updateStudyPopulation = async (payload: any) =>{
  return await doPatch(STUDY_POPULATION_URL, payload, true)
}
